import {
  InformationCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from '@heroicons/react/20/solid';
import Markdown from 'react-markdown';

export function Banner(props) {
  return (
    <div
      key={props.id}
      id={props.id}
      className={`print:hidden relative mx-auto p-4 ${props.type === 'success' ? 'bg-green-50' : props.type === 'info' ? 'bg-blue-50' : props.type === 'warning' ? 'bg-yellow-50' : props.type === 'error' ? 'bg-red-50' : 'bg-purple-50'}`}>
      <div className='flex justify-center items-center'>
        <div className='sm:ml-6 flex-shrink-0'>
          {props.type === 'success' && (
            <InformationCircleIcon className='h-5 w-5 text-green-400' aria-hidden='true' />
          )}
          {props.type === 'info' && (
            <InformationCircleIcon className='h-5 w-5 text-blue-400' aria-hidden='true' />
          )}
          {props.type === 'warning' && (
            <ExclamationTriangleIcon className='h-5 w-5 text-yellow-400' aria-hidden='true' />
          )}
          {props.type === 'error' && (
            <ExclamationTriangleIcon className='h-5 w-5 text-red-400' aria-hidden='true' />
          )}
        </div>
        <div className='ml-3 mr-6'>
          <span
            className={`text-sm font-medium ${props.type === 'success' ? 'text-green-800' : props.type === 'info' ? 'text-blue-800' : props.type === 'warning' ? 'text-yellow-800' : props.type === 'error' ? 'text-red-800' : 'text-purple-800'}`}>
            <Markdown>{props.message}</Markdown>
          </span>
        </div>
        {!props.hideDismiss && (
          <div className='absolute right-2 pl-3'>
            <div>
              {props.type === 'success' && (
                <button
                  onClick={() => props.acknowledgeBanner(props)}
                  type='button'
                  className='inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50'>
                  <span className='sr-only'>Dismiss</span>
                  <XMarkIcon className='h-5 w-5' aria-hidden='true' />
                </button>
              )}
              {props.type === 'info' && (
                <button
                  onClick={() => props.acknowledgeBanner(props)}
                  type='button'
                  className='inline-flex rounded-md bg-blue-50 p-1.5 text-blue-500 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-blue-50'>
                  <span className='sr-only'>Dismiss</span>
                  <XMarkIcon className='h-5 w-5' aria-hidden='true' />
                </button>
              )}
              {props.type === 'warning' && (
                <button
                  onClick={() => props.acknowledgeBanner(props)}
                  type='button'
                  className='inline-flex rounded-md bg-yellow-50 p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-offset-2 focus:ring-offset-yellow-50'>
                  <span className='sr-only'>Dismiss</span>
                  <XMarkIcon className='h-5 w-5' aria-hidden='true' />
                </button>
              )}
              {props.type === 'error' && (
                <button
                  onClick={() => props.acknowledgeBanner(props)}
                  type='button'
                  className='inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50'>
                  <span className='sr-only'>Dismiss</span>
                  <XMarkIcon className='h-5 w-5' aria-hidden='true' />
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
